import { useAction } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { TradingAudit } from '@root/entities/pair/ui/common'
import { skipShowAuditAction } from '@root/features/trade/trading'
import {
  Drawer,
  FadeOverflow,
  type DrawerControlProps,
} from '@root/shared/ui-kit'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps &
  DrawerControlProps

export const TradeAuditDrawer: React.FC<Props> = ({
  className,
  open,
  onOpenChange,
  pair,
}) => {
  const { t } = useTranslation()
  const skipShowAudit = useAction(skipShowAuditAction)
  return (
    <Root
      title={t('common.audit')}
      className={className}
      open={open}
      onOpenChange={onOpenChange}
    >
      <Content mode="always" variant="vertical" blockEnd={10} blockStart={10}>
        <TradingAudit
          pair={pair}
          onProceed={() => onOpenChange?.(false)}
          onNeverShowAgain={() => {
            skipShowAudit()
            onOpenChange?.(false)
          }}
        />
      </Content>
    </Root>
  )
}

const Root = styled(Drawer)`
  align-items: start;
  height: var(--max-drawer-height);
`

const Content = styled(FadeOverflow)`
  padding-inline: 12px;
  overflow-y: auto;
  padding-block: 10px;
`
